import { Checkbox, GroupBox, TextInput } from '@infotech-soe/erp-ui-kit';
import React, { memo } from 'react';
import { useIntl } from 'react-intl';

import { messages } from './messages';
import { InputConditionsProps, InputName } from './types';

type Props = Pick<
  InputConditionsProps<string | boolean>,
  'condition' | 'onChange'
>;

const TextConditions = ({ condition, onChange }: Props): React.JSX.Element => {
  const { formatMessage } = useIntl();

  return (
    <GroupBox label={formatMessage(messages.condition)}>
      <GroupBox.Content className="row gutter-x-md">
        <div className="row col-12">
          <TextInput
            className="col m-mr-sm"
            value={condition.value.pattern ?? ''}
            name={InputName.PATTERN}
            onChange={(v: string) => onChange(v, InputName.PATTERN)}
          />
          <Checkbox
            className="col-auto"
            label={formatMessage(messages.caseSensitive)}
            name={InputName.CASESENSITIVE}
            value={!!condition.value.caseSensitive}
            onChange={onChange}
          />
        </div>
      </GroupBox.Content>
    </GroupBox>
  );
};

export default memo(TextConditions);
